<div class="form-container">
    <h2>{{ config.title }}</h2>

    <form [formGroup]="form" (ngSubmit)="submit()">
    <div *ngFor="let field of config.fields" class="field-block">
        <label>{{ field.label }}</label>
        <!--
        <input 
        type="text"
        [formControlName]="field.store_key"
        [placeholder]="field.placeholder || ''"
        />
    -->
 <!-- Text input -->
      <input *ngIf="!field.type || field.type === 'text'" 
             type="text"
             [formControlName]="field.store_key"
             [placeholder]="field.placeholder || ''" />

      <!-- Textarea -->
      <textarea *ngIf="field.type === 'textarea'"
                [formControlName]="field.store_key"
                [placeholder]="field.placeholder || ''"></textarea>

      <!-- Select -->
      <select *ngIf="field.type === 'select'" [formControlName]="selectKeyMapping(field.store_key)">
        <option *ngFor="let option of field.options" [ngValue]="option.value">
          {{ option.label }}
        </option>
      </select>

        <small *ngIf="field.hint">{{ field.hint }}</small>
    </div>

    <button type="submit" [disabled]="loading || form.invalid">
  @if (!loading) {
    <span >{{ config.buttonLabel }}</span>
  }
  @if (loading) {
  <span  class="spinner"></span>
  }
</button>
    </form>
</div>
